import React from 'react';

import './VersionDropdown.scss';

function VersionDropdown() {

    const versions = window.buildVersions || [5];

    function handleChange(ev) {
        window.location.href = process.env.PUBLIC_URL + '/../v' + ev.target.value;
    }

    return <div className="version-dropdown">
        <select onChange={handleChange} defaultValue={5}>
            {versions.map(v => (
                <option key={v} value={v}>{v}.0</option>
            ))}
        </select>
    </div>;
}

export default VersionDropdown;